@if (isNavigationPending()) {
  <div class="fixed inset-0 z-app-overlay-50">
    <gc-spinner></gc-spinner>
  </div>
  <p-progressbar class="absolute top-0 left-0 w-full" styleClass="!rounded-none !h-1"
                 mode="indeterminate"></p-progressbar>
}

<p-toast #appToast
         [key]="ToastKey.App"
         styleClass="!z-app-overlay-10">
  <ng-template #message let-message>
    <gc-toast-content [message]="message" [toast]="appToast"></gc-toast-content>
  </ng-template>
</p-toast>

<router-outlet></router-outlet>
